import ApplicationEntity from './appEntity';
import { createSession } from './sessionUtil';
import { getLinkToken, awaitWrap } from './util';
import { ACTION_TYPES_CREATING_SESSION, ACTION_TYPES_SERVICE_ERROR } from '../app/reducers';
import { optInSession, optOutSession, reportClientLog } from '../service/ViewerService';
import { LOG_TYPE } from './constants';

export const createSessionBusiness = async (isExpired, isOnlyFunctionCookies, isStrictlyNecessaryCookies, dispatch) => {
    const [error, sessionId] = await awaitWrap(createSession(isExpired, isOnlyFunctionCookies, isStrictlyNecessaryCookies, dispatch));
    if (sessionId) {
        ApplicationEntity.getInstance().sessionId = sessionId;
    } else {
        dispatch({ type: ACTION_TYPES_SERVICE_ERROR, payload: error });

        const extraInfo = {
            linkToken: getLinkToken()
        };
        const logInfo = {
            LogType: LOG_TYPE.ERROR,
            Message: 'createSession failed after switching to all tracking!',
            Detail: error,
            ExtraInfo: extraInfo
        };
        reportClientLog(logInfo);
    }

    dispatch({ type: ACTION_TYPES_CREATING_SESSION, payload: false });
    return [error, sessionId];
};

export const optInSessionBusiness = async (tenant, sessionId) => {
    const [error, data] = await awaitWrap(optInSession(tenant, sessionId));

    if (error) {
        const extraInfo = {
            linkToken: getLinkToken(),
            tenant,
            sessionId
        };
        const logInfo = {
            LogType: LOG_TYPE.ERROR,
            Message: 'optInSession failed after switching to all tracking!',
            Detail: error,
            ExtraInfo: extraInfo
        };
        reportClientLog(logInfo);
    }

    return [error, data];
};

export const optOutSessionBusiness = async (tenant, sessionId) => {
    const [error, data] = await awaitWrap(optOutSession(tenant, sessionId));

    if (error) {
        const extraInfo = {
            linkToken: getLinkToken(),
            tenant,
            sessionId
        };
        const logInfo = {
            LogType: LOG_TYPE.ERROR,
            Message: 'optOutSession failed after switching to all tracking!',
            Detail: error,
            ExtraInfo: extraInfo
        };
        reportClientLog(logInfo);
    }

    return [error, data];
};
